const satributeSymbols = (satributes: string[]): string[] => {
	let satributeSymbols: string[] = []
	if (satributes?.includes('uncommon')) {
		satributeSymbols = [...satributeSymbols, '💎']
	}

	if (satributes?.includes('rare')) {
		satributeSymbols = [...satributeSymbols, '💠']
	}

	if (satributes?.includes('epic')) {
		satributeSymbols = [...satributeSymbols, '❇️']
	}

	if (satributes?.includes('vintage')) {
		satributeSymbols = [...satributeSymbols, '⏳']
	}

	if (satributes?.includes('nakamoto')) {
		satributeSymbols = [...satributeSymbols, '🥷']
	}

	if (satributes?.includes('palindrome')) {
		satributeSymbols = [...satributeSymbols, '🦋']
	}

	if (satributes?.includes('pizza')) {
		satributeSymbols = [...satributeSymbols, '🍕']
	}

	if (satributes?.includes('block 9')) {
		satributeSymbols = [...satributeSymbols, '9️⃣']
	}

	if (satributes?.includes('block 69')) {
		satributeSymbols = [...satributeSymbols, '6️⃣9️⃣']
	}

	if (satributes?.includes('block 78')) {
		satributeSymbols = [...satributeSymbols, '7️⃣8️⃣']
	}

	if (satributes?.includes('first transaction')) {
		satributeSymbols = [...satributeSymbols, '🥇']
	}

	return satributeSymbols
}

export default satributeSymbols
